export default "__VITE_PUBLIC_ASSET__7da52002__"